import Button from '@zenbusiness/common-components/Button';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const ViewerContainer = styled(Box)(
  ({ theme }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    minHeight: '100%',
    zIndex: 1201,
    backgroundColor: theme.palette.focus00.main
  })
);

export const Viewer = styled(Box)({
  width: '100%',
  marginTop: '3.125rem'
});

export const StickyHeader = styled(Box)(
  ({ theme }) => ({
    width: '100%',
    position: 'fixed',
    top: 0,
    zIndex: 1202,
    backgroundColor: theme.palette.focus00.main
  })
);

export const StickyFooter = styled(Box)(
  ({ theme }) => ({
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      position: 'fixed',
      bottom: 0,
      zIndex: 1202
    }
  })
);

export const ButtonContainer = styled(Box)(
  ({ theme }) => ({
    width: '100%',
    padding: '0.5rem 1rem',
    backgroundColor: `${theme.palette.focus00.main}80`,
    backdropFilter: 'blur(12px)',

    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '1rem'
    }
  })
);

export const DoneButton = styled(Button)(
  ({ theme }) => ({
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 'unset'
    }
  })
);
